import { Typography } from '@material-ui/core/';
import { Skeleton } from '@material-ui/lab';
import React from 'react';
import { useStyles, MetricCardBase } from './metrics/MetricCard';
import MetricCardError from './metrics/MetricCardError';
export function PaidLicensesMetricCard(_a) {
    var requestState = _a.requestState;
    var classes = useStyles();
    var status = requestState.status, error = requestState.error, details = requestState.result;
    var label = React.createElement(Typography, { variant: "body1" }, "Paid Licenses");
    if (error) {
        var metric_1 = React.createElement(MetricCardError, { onClick: function () { } });
        return React.createElement(MetricCardBase, { metric: metric_1, label: label });
    }
    if (status === 'loading') {
        var metric_2 = React.createElement(Skeleton, { variant: "rect" });
        var label_1 = (React.createElement(React.Fragment, null,
            React.createElement(Typography, { display: "inline", variant: "body1" }, "Paid licenses"),
            React.createElement(Typography, { style: { marginLeft: '8px' }, display: "inline", variant: "body2" }, "(Next renewal"),
            React.createElement(Skeleton, { variant: "text", className: classes.inlineSkeleton },
                React.createElement(Typography, { display: "inline", variant: "body2" }, "July 4, 2000")),
            React.createElement(Typography, { display: "inline", variant: "body2" }, ")")));
        return React.createElement(MetricCardBase, { metric: metric_2, label: label_1 });
    }
    if (!details) {
        // This should never happen.
        // FIXME: Trigger some kind of system notifaction here.
        var metric_3 = React.createElement(MetricCardError, { onClick: function () { } });
        return React.createElement(MetricCardBase, { metric: metric_3, label: label });
    }
    var metric = React.createElement(Typography, { variant: "h2" }, details.paidLicenses.toLocaleString());
    label = (React.createElement(React.Fragment, null,
        React.createElement(Typography, { variant: "body1", display: "inline" }, "Paid Licenses"),
        React.createElement(Typography, { style: { marginLeft: '8px' }, variant: "body2", display: "inline" },
            "(Next renewal: ",
            details.licenseRenewalDate,
            ")")));
    return React.createElement(MetricCardBase, { metric: metric, label: label });
}
//# sourceMappingURL=PaidLicensesMetricCard.js.map